export const content = {
  title: "Flighting",
  subtitle:
    "View your channel mix and ROI to see how your spend and flighting patterns impact ROI over time.",
};

export const noDataContent = {
  title: "Insufficient Data",
  description:
    "Sorry, there is not enough data to show this module. Try selecting a difference business unit or adjusting your date range.",
};
